module.exports = __webpack_public_path__ + "img/wygl1.a28c10ab.png";